const styles = {
	wrapper: {
		display: 'flex',
		flexDirection: 'column',
		minHeight: '100vh',
		padding: 30,
	},
	title: {
		color: 'primary',
		fontWeight: 600,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		width: '100%',
		maxWidth: 750,
		marginX: 'auto',
		button: {
			marginRight: [-20, 0],
		},
	},
	totalPrice: {
		width: 'calc(100% + 60px)',
		padding: '15px 30px',
		marginTop: 30,
		marginLeft: '-30px',
		backgroundColor: 'background',
		position: 'relative',
		'&::after': {
			content: '""',
			position: 'absolute',
			right: 0,
			bottom: -40,
			width: '100%',
			height: '40px',
			background: 'linear-gradient(white, transparent)',
			zIndex: 1,
			pointerEvents: 'none',
		},
		'>div': {
			width: '100%',
			maxWidth: 750,
			marginX: 'auto',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'space-between',
		},
		h4: {
			fontFamily: 'body',
			fontSize: 1,
			color: 'primary',
		},
		div: {
			fontSize: 1,
		},
	},
	cartItems: {
		flexGrow: 1,
		overflow: 'hidden',
		paddingTop: 20,
		width: '100%',
		maxWidth: 750,
		marginX: 'auto',
		maxHeight: 'calc(100vh - 250px)',
		'> div': {
			paddingRight: 30,
			marginRight: -30,
			maxHeight: 'calc(100vh - 250px)',
			overflow: 'auto',
		},
	},
	buttonStyle: {
		width: '100%',
		maxWidth: 750,
		marginX: 'auto',
		backgroundColor: 'white',
		position: 'relative',
		'&::before': {
			content: '""',
			position: 'absolute',
			right: 0,
			top: -40,
			width: '100%',
			height: '40px',
			background: 'linear-gradient(transparent, white)',
			zIndex: 1,
			pointerEvents: 'none',
		},
		button: {
			width: '100%',
		},
	},
};

export default styles;
